// Utils
import getStrapiImageSize from '@/utils/getStrapiImageSize';
import cn from '@/utils/cn';

// Types
import type { Media } from '@/types/MediaType';

// Styles
import styles from './StrapiMedia.module.css';

interface StrapiMediaProps {
  image: Media;
  format?: 'thumbnail' | 'small' | 'medium' | 'large' | 'xlarge';
  className?: string;
  fill?: boolean;
}

export default function StrapiMedia({ image, format = 'large', className, fill = false }: StrapiMediaProps) {
  const img = getStrapiImageSize(image, format);

  if (!img) return null;

  return (
    <img src={img.url} alt={img.alternativeText || 'image'} className={cn([className, fill ? styles.fill : null])} />
  );
}
